import React from 'react'

interface IProps {
  icon?: string
  label: string | JSX.Element
}

class IconLabel extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <React.Fragment>
        {this.props.icon && <i className={`${this.props.icon} mr-1 mr-sm-2`} />}
        {this.props.label}
      </React.Fragment>
    )
  }
}

export default IconLabel
